import * as React from "react";

//@ts-ignore Issue with TTF import
import tumorLabelFontPath from "../../../fonts/Poppins-Medium.ttf";
import { Coordinates, EllipseCoordinates } from "../../../api/patientScans";

//@ts-ignore Stub declaration
window["process"] = {};
window["__dirname"] = "";
// eslint-disable-next-line no-undef
const TextToSVG = require("text-to-svg");

interface ProstateTumorImageProps {
  tumors: { [key: string]: Coordinates | EllipseCoordinates };
  tumorsByLabel: string[][];
  currentTumorLabel: number;
  onPointerDown: (event: React.PointerEvent) => void;
  onPointerMove: (event: React.PointerEvent) => void;
  onContextMenu: (event: React.MouseEvent) => void;
  onPointerUp: (event: React.PointerEvent) => void;
  onPointerLeave: () => void;
  markerColor: string;
}

const ProstateTumorImage = React.forwardRef<
  SVGSVGElement,
  ProstateTumorImageProps
>(
  (
    {
      tumors,
      tumorsByLabel,
      currentTumorLabel,
      onPointerDown,
      onPointerMove,
      onContextMenu,
      onPointerUp,
      onPointerLeave,
      markerColor,
    },
    ref
  ) => {
    const [textToSvg, setTextToSvg] = React.useState<any | undefined>();

    React.useEffect(() => {
      TextToSVG.load(tumorLabelFontPath, (err: string, innerTextToSvg: any) => {
        if (err) {
          console.error(err);
        }
        setTextToSvg(innerTextToSvg);
      });
    }, []);

    interface EllipseCoordinatesWithLabel extends EllipseCoordinates {
      id: string;
      label: number;
    }

    const tumorsWithLabel: EllipseCoordinatesWithLabel[] = tumorsByLabel.reduce(
      (prev, tumorIds, index) => {
        tumorIds.forEach((tumorId) => {
          prev.push({
            ...(tumors[tumorId] as EllipseCoordinates),
            id: tumorId,
            label: index + 1,
          });
        });
        return prev;
      },
      [] as EllipseCoordinatesWithLabel[]
    );

    // Convert ellipse represented by two focus points
    // to a standard SVG representation (cx, cy, rx, ry)
    function toEllipse({
      id,
      x1,
      y1,
      x2,
      y2,
      label,
    }: EllipseCoordinatesWithLabel) {
      const cx = Math.round((x1 + x2) / 2);
      const cy = Math.round((y1 + y2) / 2);
      let rx, ry;
      if (Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2) < 20) {
        //if (x1 === x2 && y1 === y2) {
        rx = 15;
        ry = 15;
      } else {
        ry = Math.max(
          Math.round(Math.sqrt(((cx - x1) ** 2 + (cy - y1) ** 2) / 3)),
          15
        );
        rx = Math.max(1.5 * ry, 15);
      }

      const rotationAngle = Math.round(
        (Math.atan2(y1 - y2, x1 - x2) * 180) / Math.PI
      );
      const path = `M${cx - rx},${cy}a${rx},${ry} ${rotationAngle} 1,0 ${
        2 * rx
      },0a${rx},${ry} ${rotationAngle} 1,0 ${-2 * rx},0`;

      const textPath = textToSvg.getD(label.toString(), {
        x: cx,
        y: cy,
        fontSize: 25,
        anchor: "center middle",
      });

      return (
        <g key={id} id={id}>
          <path
            d={path}
            fill={label === currentTumorLabel + 1 ? "#fff" : markerColor}
            stroke={
              label === currentTumorLabel + 1 ? markerColor : "transparent"
            }
            strokeWidth={2}
            fillOpacity={0.5}
          />
          <path
            d={textPath}
            id={`${id}-label`}
            fill={label === currentTumorLabel + 1 ? markerColor : "#fff"}
          />
        </g>
      );
    }

    return (
      <svg
        id="ProstateTumorImage"
        ref={ref as React.LegacyRef<SVGSVGElement>}
        viewBox="0 0 1024 768"
        width="100%"
        height="100%"
        fill="none"
        style={{ maxHeight: "77vh" }}
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerLeave={onPointerLeave}
        onContextMenu={onContextMenu}
      >
        <rect width={1024} height={768} fill="#E5E5E5" />
        <g id="Prostate SVG">
          <rect width={1024} height={768} fill="white" />
          <path
            id="Base"
            d="M671.538 265.152C671.943 265.216 672.311 265.381 672.642 265.648C672.983 265.914 673.25 266.245 673.442 266.64C673.644 267.034 673.746 267.456 673.746 267.904C673.746 268.469 673.602 268.981 673.314 269.44C673.026 269.888 672.604 270.245 672.05 270.512C671.506 270.768 670.86 270.896 670.114 270.896H665.954V259.744H669.954C670.711 259.744 671.356 259.872 671.89 260.128C672.423 260.373 672.823 260.709 673.09 261.136C673.356 261.562 673.49 262.042 673.49 262.576C673.49 263.237 673.308 263.786 672.946 264.224C672.594 264.65 672.124 264.96 671.538 265.152ZM667.41 264.56H669.858C670.54 264.56 671.068 264.4 671.442 264.08C671.815 263.76 672.002 263.317 672.002 262.752C672.002 262.186 671.815 261.744 671.442 261.424C671.068 261.104 670.53 260.944 669.826 260.944H667.41V264.56ZM669.986 269.696C670.711 269.696 671.276 269.525 671.682 269.184C672.087 268.842 672.29 268.368 672.29 267.76C672.29 267.141 672.076 266.656 671.65 266.304C671.223 265.941 670.652 265.76 669.938 265.76H667.41V269.696H669.986ZM675.222 266.48C675.222 265.584 675.403 264.8 675.766 264.128C676.129 263.445 676.625 262.917 677.254 262.544C677.894 262.17 678.603 261.984 679.382 261.984C680.15 261.984 680.817 262.149 681.382 262.48C681.947 262.81 682.369 263.226 682.646 263.728V262.128H684.118V270.896H682.646V269.264C682.358 269.776 681.926 270.202 681.35 270.544C680.785 270.874 680.123 271.04 679.366 271.04C678.587 271.04 677.883 270.848 677.254 270.464C676.625 270.08 676.129 269.541 675.766 268.848C675.403 268.154 675.222 267.365 675.222 266.48ZM682.646 266.496C682.646 265.834 682.513 265.258 682.246 264.768C681.979 264.277 681.617 263.904 681.158 263.648C680.71 263.381 680.214 263.248 679.67 263.248C679.126 263.248 678.63 263.376 678.182 263.632C677.734 263.888 677.377 264.261 677.11 264.752C676.843 265.242 676.71 265.818 676.71 266.48C676.71 267.152 676.843 267.738 677.11 268.24C677.377 268.73 677.734 269.109 678.182 269.376C678.63 269.632 679.126 269.76 679.67 269.76C680.214 269.76 680.71 269.632 681.158 269.376C681.617 269.109 681.979 268.73 682.246 268.24C682.513 267.738 682.646 267.157 682.646 266.496ZM689.683 271.04C689.011 271.04 688.408 270.928 687.875 270.704C687.341 270.469 686.92 270.149 686.611 269.744C686.301 269.328 686.131 268.853 686.099 268.32H687.603C687.645 268.757 687.848 269.114 688.211 269.392C688.584 269.669 689.069 269.808 689.667 269.808C690.221 269.808 690.659 269.685 690.979 269.44C691.299 269.194 691.459 268.885 691.459 268.512C691.459 268.128 691.288 267.845 690.947 267.664C690.605 267.472 690.077 267.285 689.363 267.104C688.712 266.933 688.179 266.762 687.763 266.592C687.357 266.41 687.005 266.149 686.707 265.808C686.419 265.456 686.275 264.997 686.275 264.432C686.275 263.984 686.408 263.573 686.675 263.2C686.941 262.826 687.32 262.533 687.811 262.32C688.301 262.096 688.861 261.984 689.491 261.984C690.461 261.984 691.245 262.229 691.843 262.72C692.44 263.21 692.76 263.882 692.803 264.736H691.347C691.315 264.277 691.128 263.909 690.787 263.632C690.456 263.354 690.008 263.216 689.443 263.216C688.92 263.216 688.504 263.328 688.195 263.552C687.885 263.776 687.731 264.069 687.731 264.432C687.731 264.72 687.821 264.96 688.003 265.152C688.195 265.333 688.429 265.482 688.707 265.6C688.995 265.706 689.389 265.829 689.891 265.968C690.52 266.138 691.032 266.309 691.427 266.48C691.821 266.64 692.157 266.885 692.435 267.216C692.723 267.546 692.872 267.978 692.883 268.512C692.883 268.992 692.749 269.424 692.483 269.808C692.216 270.192 691.837 270.496 691.347 270.72C690.867 270.933 690.312 271.04 689.683 271.04ZM702.938 266.176C702.938 266.453 702.922 266.746 702.89 267.056H695.882C695.935 267.92 696.229 268.597 696.762 269.088C697.306 269.568 697.962 269.808 698.73 269.808C699.359 269.808 699.882 269.664 700.298 269.376C700.725 269.077 701.023 268.682 701.194 268.192H702.762C702.527 269.034 702.058 269.722 701.354 270.256C700.65 270.778 699.775 271.04 698.73 271.04C697.898 271.04 697.151 270.853 696.49 270.48C695.839 270.106 695.327 269.578 694.954 268.896C694.581 268.202 694.394 267.402 694.394 266.496C694.394 265.589 694.575 264.794 694.938 264.112C695.301 263.429 695.807 262.906 696.458 262.544C697.119 262.17 697.877 261.984 698.73 261.984C699.562 261.984 700.298 262.165 700.938 262.528C701.578 262.89 702.069 263.392 702.41 264.032C702.762 264.661 702.938 265.376 702.938 266.176ZM701.434 265.872C701.434 265.317 701.311 264.842 701.066 264.448C700.821 264.042 700.485 263.738 700.058 263.536C699.642 263.322 699.178 263.216 698.666 263.216C697.93 263.216 697.301 263.45 696.778 263.92C696.266 264.389 695.973 265.04 695.898 265.872H701.434Z"
            fill="#686868"
          />
          <path
            id="EPE"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M374.676 66.3878C397.441 94.9963 428.956 116.336 465.145 126.383C481.21 130.873 492.324 145.513 492.324 162.199C492.324 165.874 495.302 168.857 498.982 168.857C506.354 168.857 518.159 168.857 525.53 168.857C529.211 168.857 532.194 165.874 532.194 162.199C532.194 162.199 532.194 162.199 532.199 162.199C532.199 145.519 543.302 130.879 559.367 126.388C595.485 116.357 626.944 95.0835 649.703 66.5519C772.226 119.796 858 241.96 858 383.997C858 574.958 702.963 730 512.003 730C321.037 730 166 574.958 166 383.997C166 241.827 251.938 119.565 374.676 66.3878ZM512.003 546.77C512.049 545.463 512.587 544.222 513.52 543.299C514.489 542.341 515.806 541.803 517.175 541.818C518.892 541.818 520.604 541.828 521.527 541.854C557.04 542.94 591.61 552.629 607.285 578.059C613.924 588.829 617.517 602.464 616.282 619.708C616.087 622.389 613.862 624.46 611.176 624.46H610.433L610.428 624.491C611.73 624.624 612.939 625.254 613.801 626.259C614.775 627.392 615.2 628.899 614.969 630.381C614.57 633.072 614.118 636.009 613.831 637.608C609.577 661.086 603.067 677.263 595.629 687.802C588.734 697.578 580.825 703.068 572.762 705.564C559.403 709.701 544.937 705.682 532.004 695.825C527.335 692.267 521.957 690.114 516.426 689.371C513.981 689.033 512.136 686.998 512.018 684.547H511.997C511.88 687.003 510.029 689.043 507.579 689.381C502.068 690.109 496.712 692.247 492.062 695.773C492.042 695.794 492.016 695.809 491.996 695.825C479.063 705.682 464.597 709.701 451.244 705.564C443.18 703.068 435.271 697.578 428.371 687.802C425.111 683.184 422.035 677.489 419.247 670.569C415.233 660.629 411.824 648.163 409.343 632.764C409.256 632.221 409.128 631.344 408.99 630.355C408.764 628.879 409.2 627.377 410.169 626.249C411.04 625.234 412.27 624.609 413.588 624.486L413.583 624.465H412.824C410.138 624.465 407.908 622.389 407.713 619.713C406.488 602.464 410.076 588.829 416.715 578.059C431.703 553.751 463.951 543.827 497.783 542.049C499.808 541.941 503.627 541.89 506.795 541.864C508.168 541.838 509.491 542.371 510.47 543.335C511.398 544.248 511.941 545.478 511.997 546.77H512.003ZM512.003 515.896C512.003 512.348 512.003 512.236 512.003 515.798C512.003 517.336 511.311 518.797 510.116 519.771C509.306 520.437 508.471 521.124 508.173 521.36C507.517 521.883 506.851 522.385 506.184 522.877C481.246 541.233 449.352 539.552 428.73 522.231C413.598 509.514 404.012 488.21 408.472 459.391C408.78 457.397 409.149 455.398 409.574 453.399C410.087 451.041 412.173 449.354 414.582 449.354C417.791 449.349 414.131 448.586 413.167 447.284C412.199 445.981 411.906 444.295 412.373 442.742C424.716 403.343 458.507 366.425 502.745 363.027C503.575 362.96 505.108 362.919 506.692 362.893C508.081 362.842 509.429 363.36 510.434 364.329C511.434 365.292 511.997 366.625 511.997 368.014C512.003 370.818 512.003 368.009 512.003 368.009C512.003 366.63 512.556 365.308 513.546 364.344C514.535 363.38 515.868 362.852 517.246 362.888C519.194 362.94 521.194 363.011 522.321 363.114C566.036 367.02 599.386 403.661 611.617 442.747C612.083 444.295 611.791 445.976 610.828 447.273C609.859 448.57 608.336 449.339 606.722 449.339C604.353 449.349 609.418 449.349 609.418 449.349C611.832 449.349 613.919 451.036 614.426 453.399C614.851 455.398 615.22 457.397 615.528 459.391C619.988 488.21 610.402 509.514 595.27 522.231C573.541 540.485 539.232 541.408 513.797 519.786C512.659 518.812 512.003 517.392 512.003 515.896ZM413.941 267.846C416.961 267.841 418.006 267.841 415.469 267.841C413.931 267.841 412.48 267.149 411.507 265.96C410.533 264.771 410.143 263.207 410.446 261.7C410.451 261.685 410.451 261.675 410.456 261.659C419.057 219 453.099 187.403 501.361 184.241C503.155 184.123 504.965 184.046 506.795 184.01C508.163 183.979 509.491 184.507 510.47 185.466C511.449 186.424 512.003 187.737 512.003 189.11C512.003 189.11 512.003 191.981 512.003 189.136C512.003 187.757 512.556 186.44 513.535 185.476C514.519 184.512 515.852 183.984 517.226 184.01C517.272 184.01 517.313 184.01 517.349 184.01C518.974 184.046 520.589 184.112 522.188 184.215C569.865 187.157 603.748 217.801 613.088 259.486C613.211 260.045 613.365 260.829 613.529 261.695C613.831 263.202 613.442 264.771 612.468 265.96C611.499 267.149 610.038 267.841 608.5 267.841H610.059C612.688 267.841 614.892 269.83 615.159 272.45C615.436 275.295 615.6 278.037 615.641 280.682C615.866 295.081 612.591 306.676 607.019 316.006C600.032 327.708 589.303 336.043 576.191 341.651C560.89 348.197 542.174 350.96 523.193 351.575C521.886 351.616 519.44 351.626 517.165 351.626C515.801 351.637 514.484 351.104 513.515 350.14C512.546 349.176 512.003 347.869 512.003 346.5C512.003 343.666 512.003 346.5 512.003 346.5C512.003 347.869 511.454 349.176 510.485 350.14C509.516 351.104 508.204 351.637 506.835 351.626C504.575 351.626 502.15 351.616 500.853 351.575C481.856 350.965 463.126 348.202 447.809 341.651C434.697 336.043 423.968 327.708 416.981 316.006C410.384 304.959 407.011 290.739 408.851 272.444C409.118 269.83 411.317 267.846 413.941 267.846ZM366.966 147.938C366.649 124.338 387.281 123.6 409.067 130.684C430.847 137.768 453.786 152.68 458.066 160.364C470.979 183.544 367.689 201.341 366.966 147.938ZM656.68 147.938C656.998 124.338 636.365 123.6 614.58 130.684C592.794 137.768 569.86 152.68 565.575 160.364C552.662 183.544 655.957 201.341 656.68 147.938Z"
            fill="#F6F6F6"
          />
          <g id="Base-Border">
            <g id="Base-BRM" filter="url(#filter0_ProstateTumorImage)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M420.743 267.837L420.708 268.055C419.835 273.675 419.48 278.879 419.592 283.697C419.648 286.35 419.851 288.881 420.185 291.305C421.408 300.192 424.41 307.566 428.803 313.663C435.873 323.497 446.54 330 459.103 334.154L461.761 335.016L465.783 336.137C477.504 339.16 490.494 340.474 503.559 340.768C505.623 340.824 507.698 340.849 509.772 340.849C510.655 340.849 511.517 340.798 512.369 340.702V346.499C512.369 347.869 511.827 349.177 510.858 350.141C509.889 351.099 508.575 351.637 507.206 351.627C504.949 351.627 502.519 351.612 501.226 351.571C482.226 350.963 463.495 348.198 448.183 341.65C435.067 336.041 424.339 327.707 417.35 316.006C410.756 304.954 407.379 290.737 409.22 272.443C409.488 269.831 411.685 267.842 414.312 267.842C417.33 267.837 420.743 267.837 420.743 267.837Z"
                fill="#DEDEDE"
              />
            </g>
            <g id="Base-BLM" filter="url(#filter1_ProstateTumorImage)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M610.426 267.837C613.059 267.837 615.26 269.831 615.529 272.448C615.808 275.293 615.97 278.037 616.011 280.685C616.234 295.084 612.963 306.674 607.388 316.006C600.404 327.707 589.677 336.041 576.561 341.65C561.258 348.193 542.543 350.957 523.563 351.571C522.255 351.612 519.81 351.627 517.538 351.627C516.168 351.637 514.855 351.099 513.886 350.136C512.917 349.177 512.369 347.864 512.369 346.499C512.369 343.664 512.369 340.702 512.369 340.702L514.971 340.849C517.279 340.849 519.592 340.818 521.895 340.747L524.05 340.692C525.557 340.626 527.068 340.56 528.574 340.494L533.078 340.2L537.547 339.804C561.258 337.44 582.987 330.588 595.114 314.789L596.22 313.282C601.622 305.608 604.863 295.941 605.152 283.814L605.172 281.359C605.136 277.2 604.766 272.772 604.036 268.055L604 267.837H610.426Z"
                fill="#DEDEDE"
              />
            </g>
            <g id="Base-TRM" filter="url(#filter2_ProstateTumorImage)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M420.743 267.837H415.839C414.302 267.837 412.846 267.147 411.872 265.96C410.904 264.769 410.513 263.206 410.817 261.7C410.817 261.685 410.822 261.67 410.822 261.654C419.43 218.999 453.468 187.4 501.733 184.24C503.524 184.123 505.334 184.047 507.16 184.007C508.535 183.981 509.859 184.504 510.838 185.463C511.816 186.421 512.369 187.74 512.369 189.109C512.369 191.965 512.369 194.973 512.369 194.973L509.772 194.831L505.284 194.917L500.881 195.186L498.299 195.449C457.536 199.76 428.828 227.17 421.443 263.922L420.743 267.837Z"
                fill="#DEDEDE"
              />
            </g>
            <g id="Base-TLM" filter="url(#filter3_ProstateTumorImage)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M514.971 194.83L519.46 194.917C521.9 195.018 524.299 195.201 526.662 195.47C531.891 196.022 536.923 196.976 541.731 198.284C543.988 198.873 546.184 199.558 548.335 200.313C576.099 210.087 595.565 232.135 602.438 260.077L603.3 263.922L604 267.837H608.875C610.411 267.837 611.867 267.147 612.841 265.955C613.815 264.769 614.2 263.201 613.896 261.695C613.734 260.828 613.581 260.041 613.455 259.484C604.117 217.802 570.236 187.151 522.559 184.215C520.961 184.113 519.348 184.047 517.72 184.012C517.685 184.012 517.644 184.007 517.598 184.007C516.219 183.981 514.89 184.509 513.906 185.473C512.927 186.436 512.369 187.755 512.369 189.135C512.369 191.98 512.369 194.973 512.369 194.973L514.971 194.83Z"
                fill="#DEDEDE"
              />
            </g>
          </g>
          <g id="Mid-Border">
            <g id="Mid-BRM" filter="url(#filter4_ProstateTumorImage)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M409.945 453.395C410.452 451.037 412.542 449.353 414.956 449.353C418.156 449.348 422.092 449.348 422.092 449.348L421.129 453.096C420.631 455.196 420.2 457.291 419.861 459.385L419.566 461.039C419.384 462.251 419.221 463.443 419.1 464.62L418.897 466.593L418.709 469.286C418.405 475.119 418.806 480.541 419.805 485.527C421.463 493.916 424.806 501.067 429.34 506.89L429.771 507.453L429.929 507.641C431.871 510.035 434.017 512.195 436.334 514.107C437.633 515.188 438.992 516.192 440.392 517.11L441.401 517.769C441.949 518.094 442.502 518.424 443.055 518.753L444.739 519.661C452.56 523.688 461.481 525.524 470.555 524.956C473.385 524.794 476.231 524.404 479.071 523.79L480.618 523.41C485.969 522.045 491.259 519.829 496.281 516.714L496.483 516.593L498.324 515.391L500.14 514.107L501.398 513.149C502.509 512.297 503.595 511.394 504.655 510.435C505.486 509.705 506.298 508.944 507.094 508.153L507.662 507.641C507.865 507.494 508.068 507.346 508.266 507.199L509.564 506.52C510.462 506.16 511.416 505.977 512.369 505.977V515.796C512.369 517.333 511.679 518.794 510.487 519.768C509.676 520.437 508.844 521.122 508.545 521.355C507.885 521.878 507.221 522.385 506.551 522.877C481.617 541.233 449.719 539.549 429.102 522.228C413.967 509.512 404.386 488.21 408.844 459.385C409.148 457.392 409.519 455.394 409.945 453.395Z"
                fill="#DEDEDE"
              />
            </g>
            <g id="Mid-BLM" filter="url(#filter5_ProstateTumorImage)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M609.788 449.348C612.202 449.348 614.291 451.037 614.799 453.395C615.225 455.394 615.59 457.392 615.899 459.385C620.358 488.21 610.777 509.512 595.637 522.228C573.908 540.482 539.601 541.41 514.165 519.783C513.029 518.809 512.374 517.389 512.374 515.893C512.369 512.347 512.369 505.977 512.369 505.977L513.794 506.114C515.052 506.357 516.265 506.926 517.279 507.823L517.644 508.153C521.048 511.526 524.679 514.376 528.463 516.714C533.479 519.824 538.759 522.04 544.11 523.404C562.237 528.045 581.161 522.902 593.253 509.456L593.694 508.98C594.115 508.472 594.541 507.965 594.967 507.453L595.997 506.114C597.265 504.415 598.431 502.609 599.491 500.697C601.155 497.679 602.545 494.398 603.62 490.862C604.051 489.442 604.426 487.987 604.751 486.485L605.197 484.208C606.405 477.28 606.486 469.54 605.172 461.039C604.863 459.02 604.482 456.996 604.021 454.978L603.615 453.096L602.646 449.348H609.788Z"
                fill="#DEDEDE"
              />
            </g>
            <g id="Mid-TRM" filter="url(#filter6_ProstateTumorImage)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M422.092 449.351H417.649C416.031 449.351 414.505 448.585 413.536 447.282C412.567 445.978 412.273 444.295 412.745 442.745C425.085 403.346 458.875 366.428 503.113 363.026C503.945 362.963 505.476 362.923 507.059 362.893C508.449 362.845 509.803 363.361 510.802 364.326C511.806 365.294 512.369 366.623 512.369 368.015C512.369 370.821 512.369 373.719 512.369 373.719L509.772 373.62C507.023 373.62 504.32 373.767 501.662 374.047L497.706 374.573C461.111 380.409 433.662 412.179 423.152 445.75L422.092 449.351Z"
                fill="#DEDEDE"
              />
            </g>
            <g id="Mid-TLM" filter="url(#filter7_ProstateTumorImage)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M512.369 373.719C512.369 373.719 512.369 370.817 512.369 368.011C512.369 366.631 512.927 365.309 513.916 364.344C514.905 363.379 516.239 362.853 517.619 362.886C519.566 362.941 521.56 363.015 522.691 363.114C566.406 367.021 599.755 403.662 611.984 442.749C612.455 444.295 612.161 445.974 611.197 447.274C610.229 448.57 608.707 449.336 607.089 449.336C604.726 449.351 602.646 449.351 602.646 449.351C601.515 445.238 600.125 441.14 598.477 437.104C586.269 406.881 560.462 379.905 527.038 374.573L523.594 374.117C522.097 373.94 520.586 373.811 519.059 373.726L514.971 373.62L512.369 373.719Z"
                fill="#DEDEDE"
              />
            </g>
          </g>
          <path
            id="Vector"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M505.253 552.641L509.772 552.599C461.588 552.599 411.913 566.585 419.47 624.464L418.928 619.166C415.144 567.45 460.046 553.487 505.253 552.641Z"
            fill="#AFAFAF"
          />
          <g id="Apex-Border">
            <g id="Apex-BRM" filter="url(#filter8_ProstateTumorImage)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M419.47 624.467L419.567 625.269C420.282 630.402 421.088 635.21 422.001 639.714C426.018 659.941 431.816 673.899 438.597 682.892C439.469 684.048 440.357 685.124 441.275 686.097C444.845 690.033 448.639 692.732 452.57 694.355L454.345 695.039C455.142 695.262 455.943 695.486 456.739 695.704L457.439 695.825C458.814 696.099 460.204 696.257 461.593 696.317L464.043 696.282L465.539 696.13C472.402 695.379 479.315 692.118 485.787 687.188C485.787 687.188 485.787 687.188 485.792 687.188C493.638 681.203 503.006 678.21 512.369 678.21V684.302C512.369 686.863 510.483 689.029 507.947 689.384C502.438 690.114 497.082 692.25 492.431 695.775C492.411 695.795 492.391 695.81 492.365 695.825C479.432 705.68 464.966 709.702 451.612 705.569C443.547 703.068 435.64 697.58 428.742 687.802C425.486 683.186 422.402 677.49 419.612 670.572C415.605 660.631 412.197 648.169 409.717 632.765C409.631 632.222 409.499 631.345 409.357 630.356C409.134 628.88 409.57 627.379 410.543 626.248C411.517 625.117 412.932 624.467 414.429 624.467C417.01 624.467 419.47 624.467 419.47 624.467Z"
                fill="#DEDEDE"
              />
            </g>
            <g id="Apex-BLM" filter="url(#filter9_ProstateTumorImage)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M610.274 624.467C611.776 624.467 613.196 625.122 614.17 626.258C615.144 627.394 615.57 628.9 615.341 630.381C614.941 633.074 614.489 636.006 614.2 637.609C609.95 661.087 603.437 677.262 596.002 687.802C589.104 697.58 581.191 703.068 573.132 705.569C559.777 709.702 545.307 705.68 532.378 695.825H532.373C527.707 692.27 522.326 690.114 516.797 689.369C514.266 689.019 512.384 686.858 512.384 684.307C512.369 681.391 512.369 678.21 512.369 678.21L515.879 678.352C520.368 678.713 524.811 679.762 529.036 681.517C530.862 682.258 532.647 683.13 534.356 684.165C535.949 685.042 537.476 686.062 538.952 687.188C544.353 691.301 550.059 694.253 555.791 695.567L558.246 696.028C559.884 696.272 561.517 696.368 563.145 696.317L565.58 696.13C567.319 695.912 569.044 695.511 570.743 694.908C577.438 692.59 583.804 687.279 589.322 678.139C596.189 666.869 601.779 649.767 605.172 625.269L605.273 624.467H610.274Z"
                fill="#DEDEDE"
              />
            </g>
            <g id="Apex-TRM" filter="url(#filter10_ProstateTumorImage)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M419.47 624.464H413.191C410.508 624.464 408.276 622.389 408.084 619.713C406.856 602.465 410.447 588.828 417.086 578.059C432.074 553.751 464.322 543.828 498.152 542.051C500.176 541.944 503.995 541.89 507.165 541.864C508.535 541.841 509.864 542.373 510.843 543.334C511.816 544.298 512.369 545.615 512.369 546.986C512.369 549.8 512.369 552.714 512.369 552.714L509.772 552.599C463.1 552.599 415.022 565.723 418.928 619.165L419.47 624.464Z"
                fill="#DEDEDE"
              />
            </g>
            <g id="Apex-TLM" filter="url(#filter11_ProstateTumorImage)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M512.369 552.714V546.944C512.369 545.577 512.917 544.264 513.891 543.303C514.86 542.339 516.178 541.806 517.543 541.818C519.262 541.818 520.977 541.829 521.9 541.856C557.409 542.943 591.98 552.626 607.657 578.059C614.296 588.828 617.882 602.466 616.655 619.713C616.457 622.386 614.231 624.457 611.548 624.457C608.575 624.465 605.273 624.465 605.273 624.465C612.592 568.396 566.204 553.518 519.491 552.641L514.971 552.599L512.369 552.714Z"
                fill="#DEDEDE"
              />
            </g>
          </g>
          <g id="Bladder">
            <g id="Vector_2" filter="url(#filter12_ProstateTumorImage)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M374.676 66.3881C416.766 48.1189 463.208 38 512.003 38C560.926 38 607.491 48.1753 649.703 66.5522C626.944 95.0837 595.485 116.357 559.367 126.388C543.302 130.879 532.199 145.519 532.199 162.199C532.194 162.199 532.194 162.199 532.194 162.199C532.194 165.874 529.211 168.858 525.53 168.858C518.159 168.858 506.354 168.858 498.983 168.858C495.302 168.858 492.324 165.874 492.324 162.199C492.324 145.514 481.211 130.874 465.146 126.383C428.956 116.336 397.441 94.9966 374.676 66.3881Z"
                fill="url(#paint0_linear_ProstateTumorImage)"
              />
            </g>
            <path
              id="Bladder_2"
              d="M484.749 92.2465C485.205 92.3185 485.619 92.5045 485.991 92.8045C486.375 93.1045 486.675 93.4765 486.891 93.9205C487.119 94.3645 487.233 94.8385 487.233 95.3425C487.233 95.9785 487.071 96.5545 486.747 97.0705C486.423 97.5745 485.949 97.9765 485.325 98.2765C484.713 98.5645 483.987 98.7085 483.147 98.7085H478.467V86.1625H482.967C483.819 86.1625 484.545 86.3065 485.145 86.5945C485.745 86.8705 486.195 87.2485 486.495 87.7285C486.795 88.2085 486.945 88.7485 486.945 89.3485C486.945 90.0925 486.741 90.7105 486.333 91.2025C485.937 91.6825 485.409 92.0305 484.749 92.2465ZM480.105 91.5805H482.859C483.627 91.5805 484.221 91.4005 484.641 91.0405C485.061 90.6805 485.271 90.1825 485.271 89.5465C485.271 88.9105 485.061 88.4125 484.641 88.0525C484.221 87.6925 483.615 87.5125 482.823 87.5125H480.105V91.5805ZM483.003 97.3585C483.819 97.3585 484.455 97.1665 484.911 96.7825C485.367 96.3985 485.595 95.8645 485.595 95.1805C485.595 94.4845 485.355 93.9385 484.875 93.5425C484.395 93.1345 483.753 92.9305 482.949 92.9305H480.105V97.3585H483.003ZM491.144 85.3885V98.7085H489.506V85.3885H491.144ZM493.324 93.7405C493.324 92.7325 493.528 91.8505 493.936 91.0945C494.344 90.3265 494.902 89.7325 495.61 89.3125C496.33 88.8925 497.128 88.6825 498.004 88.6825C498.868 88.6825 499.618 88.8685 500.254 89.2405C500.89 89.6125 501.364 90.0805 501.676 90.6445V88.8445H503.332V98.7085H501.676V96.8725C501.352 97.4485 500.866 97.9285 500.218 98.3125C499.582 98.6845 498.838 98.8705 497.986 98.8705C497.11 98.8705 496.318 98.6545 495.61 98.2225C494.902 97.7905 494.344 97.1845 493.936 96.4045C493.528 95.6245 493.324 94.7365 493.324 93.7405ZM501.676 93.7585C501.676 93.0145 501.526 92.3665 501.226 91.8145C500.926 91.2625 500.518 90.8425 500.002 90.5545C499.498 90.2545 498.94 90.1045 498.328 90.1045C497.716 90.1045 497.158 90.2485 496.654 90.5365C496.15 90.8245 495.748 91.2445 495.448 91.7965C495.148 92.3485 494.998 92.9965 494.998 93.7405C494.998 94.4965 495.148 95.1565 495.448 95.7205C495.748 96.2725 496.15 96.6985 496.654 96.9985C497.158 97.2865 497.716 97.4305 498.328 97.4305C498.94 97.4305 499.498 97.2865 500.002 96.9985C500.518 96.6985 500.926 96.2725 501.226 95.7205C501.526 95.1565 501.676 94.5025 501.676 93.7585ZM505.488 93.7405C505.488 92.7325 505.692 91.8505 506.1 91.0945C506.508 90.3265 507.066 89.7325 507.774 89.3125C508.494 88.8925 509.298 88.6825 510.186 88.6825C510.954 88.6825 511.668 88.8625 512.328 89.2225C512.988 89.5705 513.492 90.0325 513.84 90.6085V85.3885H515.496V98.7085H513.84V96.8545C513.516 97.4425 513.036 97.9285 512.4 98.3125C511.764 98.6845 511.02 98.8705 510.168 98.8705C509.292 98.8705 508.494 98.6545 507.774 98.2225C507.066 97.7905 506.508 97.1845 506.1 96.4045C505.692 95.6245 505.488 94.7365 505.488 93.7405ZM513.84 93.7585C513.84 93.0145 513.69 92.3665 513.39 91.8145C513.09 91.2625 512.682 90.8425 512.166 90.5545C511.662 90.2545 511.104 90.1045 510.492 90.1045C509.88 90.1045 509.322 90.2485 508.818 90.5365C508.314 90.8245 507.912 91.2445 507.612 91.7965C507.312 92.3485 507.162 92.9965 507.162 93.7405C507.162 94.4965 507.312 95.1565 507.612 95.7205C507.912 96.2725 508.314 96.6985 508.818 96.9985C509.322 97.2865 509.88 97.4305 510.492 97.4305C511.104 97.4305 511.662 97.2865 512.166 96.9985C512.682 96.6985 513.09 96.2725 513.39 95.7205C513.69 95.1565 513.84 94.5025 513.84 93.7585ZM517.652 93.7405C517.652 92.7325 517.856 91.8505 518.264 91.0945C518.672 90.3265 519.23 89.7325 519.938 89.3125C520.658 88.8925 521.462 88.6825 522.35 88.6825C523.118 88.6825 523.832 88.8625 524.492 89.2225C525.152 89.5705 525.656 90.0325 526.004 90.6085V85.3885H527.66V98.7085H526.004V96.8545C525.68 97.4425 525.2 97.9285 524.564 98.3125C523.928 98.6845 523.184 98.8705 522.332 98.8705C521.456 98.8705 520.658 98.6545 519.938 98.2225C519.23 97.7905 518.672 97.1845 518.264 96.4045C517.856 95.6245 517.652 94.7365 517.652 93.7405ZM526.004 93.7585C526.004 93.0145 525.854 92.3665 525.554 91.8145C525.254 91.2625 524.846 90.8425 524.33 90.5545C523.826 90.2545 523.268 90.1045 522.656 90.1045C522.044 90.1045 521.486 90.2485 520.982 90.5365C520.478 90.8245 520.076 91.2445 519.776 91.7965C519.476 92.3485 519.326 92.9965 519.326 93.7405C519.326 94.4965 519.476 95.1565 519.776 95.7205C520.076 96.2725 520.478 96.6985 520.982 96.9985C521.486 97.2865 522.044 97.4305 522.656 97.4305C523.268 97.4305 523.826 97.2865 524.33 96.9985C524.846 96.6985 525.254 96.2725 525.554 95.7205C525.854 95.1565 526.004 94.5025 526.004 93.7585ZM539.428 93.3985C539.428 93.7105 539.41 94.0405 539.374 94.3885H531.49C531.55 95.3605 531.88 96.1225 532.48 96.6745C533.092 97.2145 533.83 97.4845 534.694 97.4845C535.402 97.4845 535.99 97.3225 536.458 96.9985C536.938 96.6625 537.274 96.2185 537.466 95.6665H539.23C538.966 96.6145 538.438 97.3885 537.646 97.9885C536.854 98.5765 535.87 98.8705 534.694 98.8705C533.758 98.8705 532.918 98.6605 532.174 98.2405C531.442 97.8205 530.866 97.2265 530.446 96.4585C530.026 95.6785 529.816 94.7785 529.816 93.7585C529.816 92.7385 530.02 91.8445 530.428 91.0765C530.836 90.3085 531.406 89.7205 532.138 89.3125C532.882 88.8925 533.734 88.6825 534.694 88.6825C535.63 88.6825 536.458 88.8865 537.178 89.2945C537.898 89.7025 538.45 90.2665 538.834 90.9865C539.23 91.6945 539.428 92.4985 539.428 93.3985ZM537.736 93.0565C537.736 92.4325 537.598 91.8985 537.322 91.4545C537.046 90.9985 536.668 90.6565 536.188 90.4285C535.72 90.1885 535.198 90.0685 534.622 90.0685C533.794 90.0685 533.086 90.3325 532.498 90.8605C531.922 91.3885 531.592 92.1205 531.508 93.0565H537.736ZM543.228 90.4465C543.516 89.8825 543.924 89.4445 544.452 89.1325C544.992 88.8205 545.646 88.6645 546.414 88.6645V90.3565H545.982C544.146 90.3565 543.228 91.3525 543.228 93.3445V98.7085H541.59V88.8445H543.228V90.4465Z"
              fill="#686868"
            />
          </g>
          <g id="RSV">
            <g id="Vector_3" filter="url(#filter13_ProstateTumorImage)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M367.334 147.94C366.697 100.735 449.869 144.99 458.438 160.365C471.351 183.544 368.058 201.339 367.334 147.94Z"
                fill="white"
              />
            </g>
            <path
              id="RSV_2"
              d="M404.595 165.618L401.607 160.488H399.627V165.618H397.989V153.072H402.039C402.987 153.072 403.785 153.234 404.433 153.558C405.093 153.882 405.585 154.32 405.909 154.872C406.233 155.424 406.395 156.054 406.395 156.762C406.395 157.626 406.143 158.388 405.639 159.048C405.147 159.708 404.403 160.146 403.407 160.362L406.557 165.618H404.595ZM399.627 159.174H402.039C402.927 159.174 403.593 158.958 404.037 158.526C404.481 158.082 404.703 157.494 404.703 156.762C404.703 156.018 404.481 155.442 404.037 155.034C403.605 154.626 402.939 154.422 402.039 154.422H399.627V159.174ZM412.918 165.744C412.09 165.744 411.346 165.6 410.686 165.312C410.038 165.012 409.528 164.604 409.156 164.088C408.784 163.56 408.592 162.954 408.58 162.27H410.326C410.386 162.858 410.626 163.356 411.046 163.764C411.478 164.16 412.102 164.358 412.918 164.358C413.698 164.358 414.31 164.166 414.754 163.782C415.21 163.386 415.438 162.882 415.438 162.27C415.438 161.79 415.306 161.4 415.042 161.1C414.778 160.8 414.448 160.572 414.052 160.416C413.656 160.26 413.122 160.092 412.45 159.912C411.622 159.696 410.956 159.48 410.452 159.264C409.96 159.048 409.534 158.712 409.174 158.256C408.826 157.788 408.652 157.164 408.652 156.384C408.652 155.7 408.826 155.094 409.174 154.566C409.522 154.038 410.008 153.63 410.632 153.342C411.268 153.054 411.994 152.91 412.81 152.91C413.986 152.91 414.946 153.204 415.69 153.792C416.446 154.38 416.872 155.16 416.968 156.132H415.168C415.108 155.652 414.856 155.232 414.412 154.872C413.968 154.5 413.38 154.314 412.648 154.314C411.964 154.314 411.406 154.494 410.974 154.854C410.542 155.202 410.326 155.694 410.326 156.33C410.326 156.786 410.452 157.158 410.704 157.446C410.968 157.734 411.286 157.956 411.658 158.112C412.042 158.256 412.576 158.424 413.26 158.616C414.088 158.844 414.754 159.072 415.258 159.3C415.762 159.516 416.194 159.858 416.554 160.326C416.914 160.782 417.094 161.406 417.094 162.198C417.094 162.81 416.932 163.386 416.608 163.926C416.284 164.466 415.804 164.904 415.168 165.24C414.532 165.576 413.782 165.744 412.918 165.744ZM429.872 153.072L425.138 165.618H423.248L418.514 153.072H420.26L424.202 163.89L428.144 153.072H429.872Z"
              fill="#686868"
            />
          </g>
          <g id="LSV">
            <g id="Vector_4" filter="url(#filter14_ProstateTumorImage)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M657.051 147.94C657.688 100.735 574.516 144.99 565.947 160.365C553.034 183.544 656.326 201.339 657.051 147.94Z"
                fill="white"
              />
            </g>
            <path
              id="LSV_2"
              d="M598.717 164.285H603.109V165.617H597.079V153.071H598.717V164.285ZM608.827 165.743C607.999 165.743 607.255 165.599 606.595 165.311C605.947 165.011 605.437 164.603 605.065 164.087C604.693 163.559 604.501 162.953 604.489 162.269H606.235C606.295 162.857 606.535 163.355 606.955 163.763C607.387 164.159 608.011 164.357 608.827 164.357C609.607 164.357 610.219 164.165 610.663 163.781C611.119 163.385 611.347 162.881 611.347 162.269C611.347 161.789 611.215 161.399 610.951 161.099C610.687 160.799 610.357 160.571 609.961 160.415C609.565 160.259 609.031 160.091 608.359 159.911C607.531 159.695 606.865 159.479 606.361 159.263C605.869 159.047 605.443 158.711 605.083 158.255C604.735 157.787 604.561 157.163 604.561 156.383C604.561 155.699 604.735 155.093 605.083 154.565C605.431 154.037 605.917 153.629 606.541 153.341C607.177 153.053 607.903 152.909 608.719 152.909C609.895 152.909 610.855 153.203 611.599 153.791C612.355 154.379 612.781 155.159 612.877 156.131H611.077C611.017 155.651 610.765 155.231 610.321 154.871C609.877 154.499 609.289 154.313 608.557 154.313C607.873 154.313 607.315 154.493 606.883 154.853C606.451 155.201 606.235 155.693 606.235 156.329C606.235 156.785 606.361 157.157 606.613 157.445C606.877 157.733 607.195 157.955 607.567 158.111C607.951 158.255 608.485 158.423 609.169 158.615C609.997 158.843 610.663 159.071 611.167 159.299C611.671 159.515 612.103 159.857 612.463 160.325C612.823 160.781 613.003 161.405 613.003 162.197C613.003 162.809 612.841 163.385 612.517 163.925C612.193 164.465 611.713 164.903 611.077 165.239C610.441 165.575 609.691 165.743 608.827 165.743ZM625.781 153.071L621.047 165.617H619.157L614.423 153.071H616.169L620.111 163.889L624.053 153.071H625.781Z"
              fill="#686868"
            />
          </g>
          <g id="Apex-Inner">
            <g id="Apex-TRI">
              <g id="Vector_5" filter="url(#filter15_i_ProstateTumorImage)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.369 552.714V624.464H419.47L418.928 619.166C415.022 565.723 463.1 552.599 509.773 552.599L512.369 552.714Z"
                  fill="white"
                />
              </g>
              <path
                id="RAa"
                d="M464.244 600.252L461.256 595.122H459.276V600.252H457.638V587.706H461.688C462.636 587.706 463.434 587.868 464.082 588.192C464.742 588.516 465.234 588.954 465.558 589.506C465.882 590.058 466.044 590.688 466.044 591.396C466.044 592.26 465.792 593.022 465.288 593.682C464.796 594.342 464.052 594.78 463.056 594.996L466.206 600.252H464.244ZM459.276 593.808H461.688C462.576 593.808 463.242 593.592 463.686 593.16C464.13 592.716 464.352 592.128 464.352 591.396C464.352 590.652 464.13 590.076 463.686 589.668C463.254 589.26 462.588 589.056 461.688 589.056H459.276V593.808ZM476.005 597.462H470.533L469.525 600.252H467.797L472.333 587.778H474.223L478.741 600.252H477.013L476.005 597.462ZM475.537 596.13L473.269 589.794L471.001 596.13H475.537ZM480.106 595.284C480.106 594.276 480.31 593.394 480.718 592.638C481.126 591.87 481.684 591.276 482.392 590.856C483.112 590.436 483.91 590.226 484.786 590.226C485.65 590.226 486.4 590.412 487.036 590.784C487.672 591.156 488.146 591.624 488.458 592.188V590.388H490.114V600.252H488.458V598.416C488.134 598.992 487.648 599.472 487 599.856C486.364 600.228 485.62 600.414 484.768 600.414C483.892 600.414 483.1 600.198 482.392 599.766C481.684 599.334 481.126 598.728 480.718 597.948C480.31 597.168 480.106 596.28 480.106 595.284ZM488.458 595.302C488.458 594.558 488.308 593.91 488.008 593.358C487.708 592.806 487.3 592.386 486.784 592.098C486.28 591.798 485.722 591.648 485.11 591.648C484.498 591.648 483.94 591.792 483.436 592.08C482.932 592.368 482.53 592.788 482.23 593.34C481.93 593.892 481.78 594.54 481.78 595.284C481.78 596.04 481.93 596.7 482.23 597.264C482.53 597.816 482.932 598.242 483.436 598.542C483.94 598.83 484.498 598.974 485.11 598.974C485.722 598.974 486.28 598.83 486.784 598.542C487.3 598.242 487.708 597.816 488.008 597.264C488.308 596.7 488.458 596.046 488.458 595.302Z"
                fill="#686868"
              />
            </g>
            <g id="Apex-TLI">
              <g id="Vector_6" filter="url(#filter16_i_ProstateTumorImage)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M519.491 552.641C566.204 553.518 612.592 568.395 605.273 624.464H512.369V552.714L514.971 552.599L519.491 552.641Z"
                  fill="white"
                />
              </g>
              <path
                id="LAa"
                d="M540.357 598.75H544.749V600.082H538.719V587.536H540.357V598.75ZM553.905 597.292H548.433L547.425 600.082H545.697L550.233 587.608H552.123L556.641 600.082H554.913L553.905 597.292ZM553.437 595.96L551.169 589.624L548.901 595.96H553.437ZM558.006 595.114C558.006 594.106 558.21 593.224 558.618 592.468C559.026 591.7 559.584 591.106 560.292 590.686C561.012 590.266 561.81 590.056 562.686 590.056C563.55 590.056 564.3 590.242 564.936 590.614C565.572 590.986 566.046 591.454 566.358 592.018V590.218H568.014V600.082H566.358V598.246C566.034 598.822 565.548 599.302 564.9 599.686C564.264 600.058 563.52 600.244 562.668 600.244C561.792 600.244 561 600.028 560.292 599.596C559.584 599.164 559.026 598.558 558.618 597.778C558.21 596.998 558.006 596.11 558.006 595.114ZM566.358 595.132C566.358 594.388 566.208 593.74 565.908 593.188C565.608 592.636 565.2 592.216 564.684 591.928C564.18 591.628 563.622 591.478 563.01 591.478C562.398 591.478 561.84 591.622 561.336 591.91C560.832 592.198 560.43 592.618 560.13 593.17C559.83 593.722 559.68 594.37 559.68 595.114C559.68 595.87 559.83 596.53 560.13 597.094C560.43 597.646 560.832 598.072 561.336 598.372C561.84 598.66 562.398 598.804 563.01 598.804C563.622 598.804 564.18 598.66 564.684 598.372C565.2 598.072 565.608 597.646 565.908 597.094C566.208 596.53 566.358 595.876 566.358 595.132Z"
                fill="#686868"
              />
            </g>
            <g id="Apex-BRI">
              <g id="Vector_7" filter="url(#filter17_i_ProstateTumorImage)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M419.466 624.464H512.37V678.213C503.002 678.213 493.639 681.2 485.788 687.185C479.316 692.115 472.403 695.376 465.535 696.127C461.153 696.629 456.786 696.112 452.566 694.352C448.64 692.724 444.836 690.036 441.276 686.1C440.373 685.106 439.485 684.035 438.598 682.894L436.554 679.988C430.65 670.995 425.603 657.889 421.997 639.711C421.089 635.212 420.278 630.404 419.568 625.271L419.466 624.464Z"
                  fill="white"
                />
              </g>
              <path
                id="RAp"
                d="M463.244 656.577L460.256 651.447H458.276V656.577H456.638V644.031H460.688C461.636 644.031 462.434 644.193 463.082 644.517C463.742 644.841 464.234 645.279 464.558 645.831C464.882 646.383 465.044 647.013 465.044 647.721C465.044 648.585 464.792 649.347 464.288 650.007C463.796 650.667 463.052 651.105 462.056 651.321L465.206 656.577H463.244ZM458.276 650.133H460.688C461.576 650.133 462.242 649.917 462.686 649.485C463.13 649.041 463.352 648.453 463.352 647.721C463.352 646.977 463.13 646.401 462.686 645.993C462.254 645.585 461.588 645.381 460.688 645.381H458.276V650.133ZM475.005 653.787H469.533L468.525 656.577H466.797L471.333 644.103H473.223L477.741 656.577H476.013L475.005 653.787ZM474.537 652.455L472.269 646.119L470.001 652.455H474.537ZM481.356 648.531C481.68 647.967 482.16 647.499 482.796 647.127C483.444 646.743 484.194 646.551 485.046 646.551C485.922 646.551 486.714 646.761 487.422 647.181C488.142 647.601 488.706 648.195 489.114 648.963C489.522 649.719 489.726 650.601 489.726 651.609C489.726 652.605 489.522 653.493 489.114 654.273C488.706 655.053 488.142 655.659 487.422 656.091C486.714 656.523 485.922 656.739 485.046 656.739C484.206 656.739 483.462 656.553 482.814 656.181C482.178 655.797 481.692 655.323 481.356 654.759V661.257H479.718V646.713H481.356V648.531ZM488.052 651.609C488.052 650.865 487.902 650.217 487.602 649.665C487.302 649.113 486.894 648.693 486.378 648.405C485.874 648.117 485.316 647.973 484.704 647.973C484.104 647.973 483.546 648.123 483.03 648.423C482.526 648.711 482.118 649.137 481.806 649.701C481.506 650.253 481.356 650.895 481.356 651.627C481.356 652.371 481.506 653.025 481.806 653.589C482.118 654.141 482.526 654.567 483.03 654.867C483.546 655.155 484.104 655.299 484.704 655.299C485.316 655.299 485.874 655.155 486.378 654.867C486.894 654.567 487.302 654.141 487.602 653.589C487.902 653.025 488.052 652.365 488.052 651.609Z"
                fill="#686868"
              />
            </g>
            <g id="Apex-BLI">
              <g id="Vector_8" filter="url(#filter18_i_ProstateTumorImage)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M605.172 625.269C601.779 649.767 596.189 666.869 589.322 678.139C580.415 692.848 569.363 697.651 558.246 696.028L555.791 695.567C550.059 694.253 544.353 691.301 538.952 687.188C537.476 686.062 535.949 685.042 534.356 684.165C532.632 683.151 530.857 682.268 529.036 681.517C524.811 679.767 520.368 678.713 515.879 678.352L512.369 678.21V624.467H605.273L605.172 625.269Z"
                  fill="white"
                />
              </g>
              <path
                id="LAp"
                d="M539.357 655.243H543.749V656.575H537.719V644.029H539.357V655.243ZM552.905 653.785H547.433L546.425 656.575H544.697L549.233 644.101H551.123L555.641 656.575H553.913L552.905 653.785ZM552.437 652.453L550.169 646.117L547.901 652.453H552.437ZM559.255 648.529C559.579 647.965 560.059 647.497 560.695 647.125C561.343 646.741 562.093 646.549 562.945 646.549C563.821 646.549 564.613 646.759 565.321 647.179C566.041 647.599 566.605 648.193 567.013 648.961C567.421 649.717 567.625 650.599 567.625 651.607C567.625 652.603 567.421 653.491 567.013 654.271C566.605 655.051 566.041 655.657 565.321 656.089C564.613 656.521 563.821 656.737 562.945 656.737C562.105 656.737 561.361 656.551 560.713 656.179C560.077 655.795 559.591 655.321 559.255 654.757V661.255H557.617V646.711H559.255V648.529ZM565.951 651.607C565.951 650.863 565.801 650.215 565.501 649.663C565.201 649.111 564.793 648.691 564.277 648.403C563.773 648.115 563.215 647.971 562.603 647.971C562.003 647.971 561.445 648.121 560.929 648.421C560.425 648.709 560.017 649.135 559.705 649.699C559.405 650.251 559.255 650.893 559.255 651.625C559.255 652.369 559.405 653.023 559.705 653.587C560.017 654.139 560.425 654.565 560.929 654.865C561.445 655.153 562.003 655.297 562.603 655.297C563.215 655.297 563.773 655.153 564.277 654.865C564.793 654.565 565.201 654.139 565.501 653.587C565.801 653.023 565.951 652.363 565.951 651.607Z"
                fill="#686868"
              />
            </g>
          </g>
          <g id="Mid-Inner">
            <g id="Mid-TLI">
              <g id="Vector_9" filter="url(#filter19_i_ProstateTumorImage)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M519.059 373.726C520.586 373.807 522.097 373.936 523.594 374.117L527.038 374.573C560.467 379.905 586.274 406.884 598.477 437.104C600.125 441.14 601.515 445.238 602.646 449.351H512.369V373.719L514.971 373.62L519.059 373.726Z"
                  fill="white"
                />
              </g>
              <path
                id="LMa"
                d="M538.021 427.016H542.413V428.348H536.383V415.802H538.021V427.016ZM556.879 415.892V428.348H555.241V419.06L551.101 428.348H549.949L545.791 419.042V428.348H544.153V415.892H545.917L550.525 426.188L555.133 415.892H556.879ZM559.045 423.38C559.045 422.372 559.249 421.49 559.657 420.734C560.065 419.966 560.623 419.372 561.331 418.952C562.051 418.532 562.849 418.322 563.725 418.322C564.589 418.322 565.339 418.508 565.975 418.88C566.611 419.252 567.085 419.72 567.397 420.284V418.484H569.053V428.348H567.397V426.512C567.073 427.088 566.587 427.568 565.939 427.952C565.303 428.324 564.559 428.51 563.707 428.51C562.831 428.51 562.039 428.294 561.331 427.862C560.623 427.43 560.065 426.824 559.657 426.044C559.249 425.264 559.045 424.376 559.045 423.38ZM567.397 423.398C567.397 422.654 567.247 422.006 566.947 421.454C566.647 420.902 566.239 420.482 565.723 420.194C565.219 419.894 564.661 419.744 564.049 419.744C563.437 419.744 562.879 419.888 562.375 420.176C561.871 420.464 561.469 420.884 561.169 421.436C560.869 421.988 560.719 422.636 560.719 423.38C560.719 424.136 560.869 424.796 561.169 425.36C561.469 425.912 561.871 426.338 562.375 426.638C562.879 426.926 563.437 427.07 564.049 427.07C564.661 427.07 565.219 426.926 565.723 426.638C566.239 426.338 566.647 425.912 566.947 425.36C567.247 424.796 567.397 424.142 567.397 423.398Z"
                fill="#686868"
              />
            </g>
            <g id="Mid-TRI">
              <g id="Vector_10" filter="url(#filter20_i_ProstateTumorImage)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.369 373.719V449.351H422.092L423.152 445.75C433.657 412.183 461.111 380.409 497.706 374.573L501.662 374.047C504.32 373.767 507.023 373.62 509.772 373.62L512.369 373.719Z"
                  fill="white"
                />
              </g>
              <path
                id="RMa"
                d="M461.908 428.082L458.92 422.952H456.94V428.082H455.302V415.536H459.352C460.3 415.536 461.098 415.698 461.746 416.022C462.406 416.346 462.898 416.784 463.222 417.336C463.546 417.888 463.708 418.518 463.708 419.226C463.708 420.09 463.456 420.852 462.952 421.512C462.46 422.172 461.716 422.61 460.72 422.826L463.87 428.082H461.908ZM456.94 421.638H459.352C460.24 421.638 460.906 421.422 461.35 420.99C461.794 420.546 462.016 419.958 462.016 419.226C462.016 418.482 461.794 417.906 461.35 417.498C460.918 417.09 460.252 416.886 459.352 416.886H456.94V421.638ZM478.979 415.626V428.082H477.341V418.794L473.201 428.082H472.049L467.891 418.776V428.082H466.253V415.626H468.017L472.625 425.922L477.233 415.626H478.979ZM481.145 423.114C481.145 422.106 481.349 421.224 481.757 420.468C482.165 419.7 482.723 419.106 483.431 418.686C484.151 418.266 484.949 418.056 485.825 418.056C486.689 418.056 487.439 418.242 488.075 418.614C488.711 418.986 489.185 419.454 489.497 420.018V418.218H491.153V428.082H489.497V426.246C489.173 426.822 488.687 427.302 488.039 427.686C487.403 428.058 486.659 428.244 485.807 428.244C484.931 428.244 484.139 428.028 483.431 427.596C482.723 427.164 482.165 426.558 481.757 425.778C481.349 424.998 481.145 424.11 481.145 423.114ZM489.497 423.132C489.497 422.388 489.347 421.74 489.047 421.188C488.747 420.636 488.339 420.216 487.823 419.928C487.319 419.628 486.761 419.478 486.149 419.478C485.537 419.478 484.979 419.622 484.475 419.91C483.971 420.198 483.569 420.618 483.269 421.17C482.969 421.722 482.819 422.37 482.819 423.114C482.819 423.87 482.969 424.53 483.269 425.094C483.569 425.646 483.971 426.072 484.475 426.372C484.979 426.66 485.537 426.804 486.149 426.804C486.761 426.804 487.319 426.66 487.823 426.372C488.339 426.072 488.747 425.646 489.047 425.094C489.347 424.53 489.497 423.876 489.497 423.132Z"
                fill="#686868"
              />
            </g>
            <g id="Mid-BRI">
              <g id="Vector_11" filter="url(#filter21_i_ProstateTumorImage)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.37 505.985C511.417 505.985 510.463 506.162 509.565 506.528L508.267 507.207C508.064 507.354 507.866 507.501 507.663 507.648L507.095 508.156C506.299 508.947 505.487 509.708 504.656 510.438C503.591 511.392 502.505 512.294 501.399 513.152L500.142 514.115L498.326 515.393L496.485 516.595L496.277 516.717C491.255 519.831 485.97 522.053 480.614 523.417L479.072 523.793L477.084 524.198C475.096 524.528 475.228 524.513 473.103 524.782L470.557 524.959C461.483 525.507 452.561 523.676 444.735 519.664L443.056 518.756C442.503 518.426 441.95 518.102 441.398 517.772L440.393 517.113C438.988 516.19 437.634 515.191 436.331 514.115C434.018 512.198 431.872 510.037 429.93 507.648L429.772 507.461L429.341 506.893C424.807 501.075 421.459 493.924 419.801 485.529C418.807 480.544 418.406 475.122 418.71 469.289L418.898 466.595L419.101 464.623C419.223 463.446 419.38 462.254 419.568 461.042L420.191 457.491L420.404 456.431L420.973 453.824L421.226 452.713L422.093 449.351H512.37V505.985Z"
                  fill="white"
                />
              </g>
              <path
                id="RMp"
                d="M461.408 483.613L458.42 478.483H456.44V483.613H454.802V471.067H458.852C459.8 471.067 460.598 471.229 461.246 471.553C461.906 471.877 462.398 472.315 462.722 472.867C463.046 473.419 463.208 474.049 463.208 474.757C463.208 475.621 462.956 476.383 462.452 477.043C461.96 477.703 461.216 478.141 460.22 478.357L463.37 483.613H461.408ZM456.44 477.169H458.852C459.74 477.169 460.406 476.953 460.85 476.521C461.294 476.077 461.516 475.489 461.516 474.757C461.516 474.013 461.294 473.437 460.85 473.029C460.418 472.621 459.752 472.417 458.852 472.417H456.44V477.169ZM478.479 471.157V483.613H476.841V474.325L472.701 483.613H471.549L467.391 474.307V483.613H465.753V471.157H467.517L472.125 481.453L476.733 471.157H478.479ZM482.895 475.567C483.219 475.003 483.699 474.535 484.335 474.163C484.983 473.779 485.733 473.587 486.585 473.587C487.461 473.587 488.253 473.797 488.961 474.217C489.681 474.637 490.245 475.231 490.653 475.999C491.061 476.755 491.265 477.637 491.265 478.645C491.265 479.641 491.061 480.529 490.653 481.309C490.245 482.089 489.681 482.695 488.961 483.127C488.253 483.559 487.461 483.775 486.585 483.775C485.745 483.775 485.001 483.589 484.353 483.217C483.717 482.833 483.231 482.359 482.895 481.795V488.293H481.257V473.749H482.895V475.567ZM489.591 478.645C489.591 477.901 489.441 477.253 489.141 476.701C488.841 476.149 488.433 475.729 487.917 475.441C487.413 475.153 486.855 475.009 486.243 475.009C485.643 475.009 485.085 475.159 484.569 475.459C484.065 475.747 483.657 476.173 483.345 476.737C483.045 477.289 482.895 477.931 482.895 478.663C482.895 479.407 483.045 480.061 483.345 480.625C483.657 481.177 484.065 481.603 484.569 481.903C485.085 482.191 485.643 482.335 486.243 482.335C486.855 482.335 487.413 482.191 487.917 481.903C488.433 481.603 488.841 481.177 489.141 480.625C489.441 480.061 489.591 479.401 489.591 478.645Z"
                fill="#686868"
              />
            </g>
            <g id="Mid-BLI">
              <g id="Vector_12" filter="url(#filter22_i_ProstateTumorImage)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M602.646 449.348L603.513 452.706L603.772 453.816L604.335 456.428L604.548 457.489L605.172 461.039C606.633 470.488 606.369 478.994 604.751 486.485C604.589 487.236 604.416 487.976 604.223 488.707L603.62 490.862C602.545 494.398 601.155 497.684 599.491 500.697L599.481 500.717C598.426 502.624 597.265 504.42 595.997 506.114L594.967 507.453C594.541 507.965 594.115 508.472 593.694 508.98L593.253 509.456C581.156 522.902 562.232 528.045 544.11 523.404C538.759 522.04 533.479 519.824 528.463 516.714C524.679 514.376 521.048 511.526 517.644 508.153L517.279 507.823C516.259 506.926 515.052 506.357 513.794 506.114L512.369 505.977V449.348H602.646Z"
                  fill="white"
                />
              </g>
              <path
                id="LMp"
                d="M537.521 482.281H541.913V483.613H535.883V471.067H537.521V482.281ZM556.379 471.157V483.613H554.741V474.325L550.601 483.613H549.449L545.291 474.307V483.613H543.653V471.157H545.417L550.025 481.453L554.633 471.157H556.379ZM560.795 475.567C561.119 475.003 561.599 474.535 562.235 474.163C562.883 473.779 563.633 473.587 564.485 473.587C565.361 473.587 566.153 473.797 566.861 474.217C567.581 474.637 568.145 475.231 568.553 475.999C568.961 476.755 569.165 477.637 569.165 478.645C569.165 479.641 568.961 480.529 568.553 481.309C568.145 482.089 567.581 482.695 566.861 483.127C566.153 483.559 565.361 483.775 564.485 483.775C563.645 483.775 562.901 483.589 562.253 483.217C561.617 482.833 561.131 482.359 560.795 481.795V488.293H559.157V473.749H560.795V475.567ZM567.491 478.645C567.491 477.901 567.341 477.253 567.041 476.701C566.741 476.149 566.333 475.729 565.817 475.441C565.313 475.153 564.755 475.009 564.143 475.009C563.543 475.009 562.985 475.159 562.469 475.459C561.965 475.747 561.557 476.173 561.245 476.737C560.945 477.289 560.795 477.931 560.795 478.663C560.795 479.407 560.945 480.061 561.245 480.625C561.557 481.177 561.965 481.603 562.469 481.903C562.985 482.191 563.543 482.335 564.143 482.335C564.755 482.335 565.313 482.191 565.817 481.903C566.333 481.603 566.741 481.177 567.041 480.625C567.341 480.061 567.491 479.401 567.491 478.645Z"
                fill="#686868"
              />
            </g>
          </g>
          <g id="Base-Inner">
            <g id="Base-TLI">
              <g id="Vector_13" filter="url(#filter23_i_ProstateTumorImage)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M514.971 194.831C518.968 194.831 522.863 195.039 526.662 195.47C531.891 196.038 536.923 196.981 541.731 198.285L544.5 199.056L548.335 200.313C577.357 210.528 597.32 234.159 603.3 263.922L604 267.837H512.369V194.973L514.971 194.831Z"
                  fill="white"
                />
              </g>
              <path
                id="LBa"
                d="M540.211 245.239H544.603V246.571H538.573V234.025H540.211V245.239ZM552.625 240.109C553.081 240.181 553.495 240.367 553.867 240.667C554.251 240.967 554.551 241.339 554.767 241.783C554.995 242.227 555.109 242.701 555.109 243.205C555.109 243.841 554.947 244.417 554.623 244.933C554.299 245.437 553.825 245.839 553.201 246.139C552.589 246.427 551.863 246.571 551.023 246.571H546.343V234.025H550.843C551.695 234.025 552.421 234.169 553.021 234.457C553.621 234.733 554.071 235.111 554.371 235.591C554.671 236.071 554.821 236.611 554.821 237.211C554.821 237.955 554.617 238.573 554.209 239.065C553.813 239.545 553.285 239.893 552.625 240.109ZM547.981 239.443H550.735C551.503 239.443 552.097 239.263 552.517 238.903C552.937 238.543 553.147 238.045 553.147 237.409C553.147 236.773 552.937 236.275 552.517 235.915C552.097 235.555 551.491 235.375 550.699 235.375H547.981V239.443ZM550.879 245.221C551.695 245.221 552.331 245.029 552.787 244.645C553.243 244.261 553.471 243.727 553.471 243.043C553.471 242.347 553.231 241.801 552.751 241.405C552.271 240.997 551.629 240.793 550.825 240.793H547.981V245.221H550.879ZM556.77 241.603C556.77 240.595 556.974 239.713 557.382 238.957C557.79 238.189 558.348 237.595 559.056 237.175C559.776 236.755 560.574 236.545 561.45 236.545C562.314 236.545 563.064 236.731 563.7 237.103C564.336 237.475 564.81 237.943 565.122 238.507V236.707H566.778V246.571H565.122V244.735C564.798 245.311 564.312 245.791 563.664 246.175C563.028 246.547 562.284 246.733 561.432 246.733C560.556 246.733 559.764 246.517 559.056 246.085C558.348 245.653 557.79 245.047 557.382 244.267C556.974 243.487 556.77 242.599 556.77 241.603ZM565.122 241.621C565.122 240.877 564.972 240.229 564.672 239.677C564.372 239.125 563.964 238.705 563.448 238.417C562.944 238.117 562.386 237.967 561.774 237.967C561.162 237.967 560.604 238.111 560.1 238.399C559.596 238.687 559.194 239.107 558.894 239.659C558.594 240.211 558.444 240.859 558.444 241.603C558.444 242.359 558.594 243.019 558.894 243.583C559.194 244.135 559.596 244.561 560.1 244.861C560.604 245.149 561.162 245.293 561.774 245.293C562.386 245.293 562.944 245.149 563.448 244.861C563.964 244.561 564.372 244.135 564.672 243.583C564.972 243.019 565.122 242.365 565.122 241.621Z"
                fill="#686868"
              />
            </g>
            <g id="Base-TRI">
              <g id="Vector_14" filter="url(#filter24_i_ProstateTumorImage)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.369 194.973V267.837H420.743L421.443 263.922C428.828 227.17 457.536 199.766 498.299 195.449C500.592 195.191 502.92 195.018 505.284 194.917C506.76 194.856 508.261 194.831 509.772 194.831L512.369 194.973Z"
                  fill="white"
                />
              </g>
              <path
                id="RBa"
                d="M463.598 246.571L460.61 241.441H458.63V246.571H456.992V234.025H461.042C461.99 234.025 462.788 234.187 463.436 234.511C464.096 234.835 464.588 235.273 464.912 235.825C465.236 236.377 465.398 237.007 465.398 237.715C465.398 238.579 465.146 239.341 464.642 240.001C464.15 240.661 463.406 241.099 462.41 241.315L465.56 246.571H463.598ZM458.63 240.127H461.042C461.93 240.127 462.596 239.911 463.04 239.479C463.484 239.035 463.706 238.447 463.706 237.715C463.706 236.971 463.484 236.395 463.04 235.987C462.608 235.579 461.942 235.375 461.042 235.375H458.63V240.127ZM474.225 240.109C474.681 240.181 475.095 240.367 475.467 240.667C475.851 240.967 476.151 241.339 476.367 241.783C476.595 242.227 476.709 242.701 476.709 243.205C476.709 243.841 476.547 244.417 476.223 244.933C475.899 245.437 475.425 245.839 474.801 246.139C474.189 246.427 473.463 246.571 472.623 246.571H467.943V234.025H472.443C473.295 234.025 474.021 234.169 474.621 234.457C475.221 234.733 475.671 235.111 475.971 235.591C476.271 236.071 476.421 236.611 476.421 237.211C476.421 237.955 476.217 238.573 475.809 239.065C475.413 239.545 474.885 239.893 474.225 240.109ZM469.581 239.443H472.335C473.103 239.443 473.697 239.263 474.117 238.903C474.537 238.543 474.747 238.045 474.747 237.409C474.747 236.773 474.537 236.275 474.117 235.915C473.697 235.555 473.091 235.375 472.299 235.375H469.581V239.443ZM472.479 245.221C473.295 245.221 473.931 245.029 474.387 244.645C474.843 244.261 475.071 243.727 475.071 243.043C475.071 242.347 474.831 241.801 474.351 241.405C473.871 240.997 473.229 240.793 472.425 240.793H469.581V245.221H472.479ZM478.37 241.603C478.37 240.595 478.574 239.713 478.982 238.957C479.39 238.189 479.948 237.595 480.656 237.175C481.376 236.755 482.174 236.545 483.05 236.545C483.914 236.545 484.664 236.731 485.3 237.103C485.936 237.475 486.41 237.943 486.722 238.507V236.707H488.378V246.571H486.722V244.735C486.398 245.311 485.912 245.791 485.264 246.175C484.628 246.547 483.884 246.733 483.032 246.733C482.156 246.733 481.364 246.517 480.656 246.085C479.948 245.653 479.39 245.047 478.982 244.267C478.574 243.487 478.37 242.599 478.37 241.603ZM486.722 241.621C486.722 240.877 486.572 240.229 486.272 239.677C485.972 239.125 485.564 238.705 485.048 238.417C484.544 238.117 483.986 237.967 483.374 237.967C482.762 237.967 482.204 238.111 481.7 238.399C481.196 238.687 480.794 239.107 480.494 239.659C480.194 240.211 480.044 240.859 480.044 241.603C480.044 242.359 480.194 243.019 480.494 243.583C480.794 244.135 481.196 244.561 481.7 244.861C482.204 245.149 482.762 245.293 483.374 245.293C483.986 245.293 484.544 245.149 485.048 244.861C485.564 244.561 485.972 244.135 486.272 243.583C486.572 243.019 486.722 242.365 486.722 241.621Z"
                fill="#686868"
              />
            </g>
            <g id="Base-BRI">
              <g id="Vector_15" filter="url(#filter25_i_ProstateTumorImage)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M420.744 267.84H512.37V340.704L509.773 340.851C507.699 340.851 505.624 340.826 503.56 340.77C490.495 340.471 477.5 339.157 465.784 336.139L461.762 335.018L459.099 334.161C446.541 329.997 435.874 323.495 428.799 313.665C424.411 307.574 421.404 300.199 420.186 291.308C419.852 288.888 419.649 286.352 419.588 283.705C419.481 278.881 419.836 273.677 420.704 268.058L420.744 267.84Z"
                  fill="white"
                />
              </g>
              <path
                id="RBp"
                d="M462.598 302.103L459.61 296.973H457.63V302.103H455.992V289.557H460.042C460.99 289.557 461.788 289.719 462.436 290.043C463.096 290.367 463.588 290.805 463.912 291.357C464.236 291.909 464.398 292.539 464.398 293.247C464.398 294.111 464.146 294.873 463.642 295.533C463.15 296.193 462.406 296.631 461.41 296.847L464.56 302.103H462.598ZM457.63 295.659H460.042C460.93 295.659 461.596 295.443 462.04 295.011C462.484 294.567 462.706 293.979 462.706 293.247C462.706 292.503 462.484 291.927 462.04 291.519C461.608 291.111 460.942 290.907 460.042 290.907H457.63V295.659ZM473.225 295.641C473.681 295.713 474.095 295.899 474.467 296.199C474.851 296.499 475.151 296.871 475.367 297.315C475.595 297.759 475.709 298.233 475.709 298.737C475.709 299.373 475.547 299.949 475.223 300.465C474.899 300.969 474.425 301.371 473.801 301.671C473.189 301.959 472.463 302.103 471.623 302.103H466.943V289.557H471.443C472.295 289.557 473.021 289.701 473.621 289.989C474.221 290.265 474.671 290.643 474.971 291.123C475.271 291.603 475.421 292.143 475.421 292.743C475.421 293.487 475.217 294.105 474.809 294.597C474.413 295.077 473.885 295.425 473.225 295.641ZM468.581 294.975H471.335C472.103 294.975 472.697 294.795 473.117 294.435C473.537 294.075 473.747 293.577 473.747 292.941C473.747 292.305 473.537 291.807 473.117 291.447C472.697 291.087 472.091 290.907 471.299 290.907H468.581V294.975ZM471.479 300.753C472.295 300.753 472.931 300.561 473.387 300.177C473.843 299.793 474.071 299.259 474.071 298.575C474.071 297.879 473.831 297.333 473.351 296.937C472.871 296.529 472.229 296.325 471.425 296.325H468.581V300.753H471.479ZM479.62 294.057C479.944 293.493 480.424 293.025 481.06 292.653C481.708 292.269 482.458 292.077 483.31 292.077C484.186 292.077 484.978 292.287 485.686 292.707C486.406 293.127 486.97 293.721 487.378 294.489C487.786 295.245 487.99 296.127 487.99 297.135C487.99 298.131 487.786 299.019 487.378 299.799C486.97 300.579 486.406 301.185 485.686 301.617C484.978 302.049 484.186 302.265 483.31 302.265C482.47 302.265 481.726 302.079 481.078 301.707C480.442 301.323 479.956 300.849 479.62 300.285V306.783H477.982V292.239H479.62V294.057ZM486.316 297.135C486.316 296.391 486.166 295.743 485.866 295.191C485.566 294.639 485.158 294.219 484.642 293.931C484.138 293.643 483.58 293.499 482.968 293.499C482.368 293.499 481.81 293.649 481.294 293.949C480.79 294.237 480.382 294.663 480.07 295.227C479.77 295.779 479.62 296.421 479.62 297.153C479.62 297.897 479.77 298.551 480.07 299.115C480.382 299.667 480.79 300.093 481.294 300.393C481.81 300.681 482.368 300.825 482.968 300.825C483.58 300.825 484.138 300.681 484.642 300.393C485.158 300.093 485.566 299.667 485.866 299.115C486.166 298.551 486.316 297.891 486.316 297.135Z"
                fill="#686868"
              />
            </g>
            <g id="Base-BLI">
              <g id="Vector_16" filter="url(#filter26_i_ProstateTumorImage)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M604.036 268.055C604.766 272.772 605.136 277.2 605.172 281.359L605.152 283.814C604.837 296.748 601.175 306.887 595.114 314.789C582.221 331.577 558.499 338.262 533.078 340.2L528.574 340.494C527.068 340.56 525.557 340.626 524.05 340.692L519.511 340.808L514.971 340.849L512.369 340.702V267.837H604L604.036 268.055Z"
                  fill="white"
                />
              </g>
              <path
                id="LBp"
                d="M539.211 300.681H543.603V302.013H537.573V289.467H539.211V300.681ZM551.625 295.551C552.081 295.623 552.495 295.809 552.867 296.109C553.251 296.409 553.551 296.781 553.767 297.225C553.995 297.669 554.109 298.143 554.109 298.647C554.109 299.283 553.947 299.859 553.623 300.375C553.299 300.879 552.825 301.281 552.201 301.581C551.589 301.869 550.863 302.013 550.023 302.013H545.343V289.467H549.843C550.695 289.467 551.421 289.611 552.021 289.899C552.621 290.175 553.071 290.553 553.371 291.033C553.671 291.513 553.821 292.053 553.821 292.653C553.821 293.397 553.617 294.015 553.209 294.507C552.813 294.987 552.285 295.335 551.625 295.551ZM546.981 294.885H549.735C550.503 294.885 551.097 294.705 551.517 294.345C551.937 293.985 552.147 293.487 552.147 292.851C552.147 292.215 551.937 291.717 551.517 291.357C551.097 290.997 550.491 290.817 549.699 290.817H546.981V294.885ZM549.879 300.663C550.695 300.663 551.331 300.471 551.787 300.087C552.243 299.703 552.471 299.169 552.471 298.485C552.471 297.789 552.231 297.243 551.751 296.847C551.271 296.439 550.629 296.235 549.825 296.235H546.981V300.663H549.879ZM558.02 293.967C558.344 293.403 558.824 292.935 559.46 292.563C560.108 292.179 560.858 291.987 561.71 291.987C562.586 291.987 563.378 292.197 564.086 292.617C564.806 293.037 565.37 293.631 565.778 294.399C566.186 295.155 566.39 296.037 566.39 297.045C566.39 298.041 566.186 298.929 565.778 299.709C565.37 300.489 564.806 301.095 564.086 301.527C563.378 301.959 562.586 302.175 561.71 302.175C560.87 302.175 560.126 301.989 559.478 301.617C558.842 301.233 558.356 300.759 558.02 300.195V306.693H556.382V292.149H558.02V293.967ZM564.716 297.045C564.716 296.301 564.566 295.653 564.266 295.101C563.966 294.549 563.558 294.129 563.042 293.841C562.538 293.553 561.98 293.409 561.368 293.409C560.768 293.409 560.21 293.559 559.694 293.859C559.19 294.147 558.782 294.573 558.47 295.137C558.17 295.689 558.02 296.331 558.02 297.063C558.02 297.807 558.17 298.461 558.47 299.025C558.782 299.577 559.19 300.003 559.694 300.303C560.21 300.591 560.768 300.735 561.368 300.735C561.98 300.735 562.538 300.591 563.042 300.303C563.558 300.003 563.966 299.577 564.266 299.025C564.566 298.461 564.716 297.801 564.716 297.045Z"
                fill="#686868"
              />
            </g>
          </g>
          <path
            id="Base_2"
            d="M671.065 262.205C671.47 262.269 671.838 262.435 672.169 262.701C672.51 262.968 672.777 263.299 672.969 263.693C673.172 264.088 673.273 264.509 673.273 264.957C673.273 265.523 673.129 266.035 672.841 266.493C672.553 266.941 672.132 267.299 671.577 267.565C671.033 267.821 670.388 267.949 669.641 267.949H665.481V256.797H669.481C670.238 256.797 670.884 256.925 671.417 257.181C671.95 257.427 672.35 257.763 672.617 258.189C672.884 258.616 673.017 259.096 673.017 259.629C673.017 260.291 672.836 260.84 672.473 261.277C672.121 261.704 671.652 262.013 671.065 262.205ZM666.937 261.613H669.385C670.068 261.613 670.596 261.453 670.969 261.133C671.342 260.813 671.529 260.371 671.529 259.805C671.529 259.24 671.342 258.797 670.969 258.477C670.596 258.157 670.057 257.997 669.353 257.997H666.937V261.613ZM669.513 266.749C670.238 266.749 670.804 266.579 671.209 266.237C671.614 265.896 671.817 265.421 671.817 264.813C671.817 264.195 671.604 263.709 671.177 263.357C670.75 262.995 670.18 262.813 669.465 262.813H666.937V266.749H669.513ZM674.749 263.533C674.749 262.637 674.931 261.853 675.293 261.181C675.656 260.499 676.152 259.971 676.781 259.597C677.421 259.224 678.131 259.037 678.909 259.037C679.677 259.037 680.344 259.203 680.909 259.533C681.475 259.864 681.896 260.28 682.173 260.781V259.181H683.645V267.949H682.173V266.317C681.885 266.829 681.453 267.256 680.877 267.597C680.312 267.928 679.651 268.093 678.893 268.093C678.115 268.093 677.411 267.901 676.781 267.517C676.152 267.133 675.656 266.595 675.293 265.901C674.931 265.208 674.749 264.419 674.749 263.533ZM682.173 263.549C682.173 262.888 682.04 262.312 681.773 261.821C681.507 261.331 681.144 260.957 680.685 260.701C680.237 260.435 679.741 260.301 679.197 260.301C678.653 260.301 678.157 260.429 677.709 260.685C677.261 260.941 676.904 261.315 676.637 261.805C676.371 262.296 676.237 262.872 676.237 263.533C676.237 264.205 676.371 264.792 676.637 265.293C676.904 265.784 677.261 266.163 677.709 266.429C678.157 266.685 678.653 266.813 679.197 266.813C679.741 266.813 680.237 266.685 680.685 266.429C681.144 266.163 681.507 265.784 681.773 265.293C682.04 264.792 682.173 264.211 682.173 263.549ZM689.21 268.093C688.538 268.093 687.935 267.981 687.402 267.757C686.869 267.523 686.447 267.203 686.138 266.797C685.829 266.381 685.658 265.907 685.626 265.373H687.13C687.173 265.811 687.375 266.168 687.738 266.445C688.111 266.723 688.597 266.861 689.194 266.861C689.749 266.861 690.186 266.739 690.506 266.493C690.826 266.248 690.986 265.939 690.986 265.565C690.986 265.181 690.815 264.899 690.474 264.717C690.133 264.525 689.605 264.339 688.89 264.157C688.239 263.987 687.706 263.816 687.29 263.645C686.885 263.464 686.533 263.203 686.234 262.861C685.946 262.509 685.802 262.051 685.802 261.485C685.802 261.037 685.935 260.627 686.202 260.253C686.469 259.88 686.847 259.587 687.338 259.373C687.829 259.149 688.389 259.037 689.018 259.037C689.989 259.037 690.773 259.283 691.37 259.773C691.967 260.264 692.287 260.936 692.33 261.789H690.874C690.842 261.331 690.655 260.963 690.314 260.685C689.983 260.408 689.535 260.269 688.97 260.269C688.447 260.269 688.031 260.381 687.722 260.605C687.413 260.829 687.258 261.123 687.258 261.485C687.258 261.773 687.349 262.013 687.53 262.205C687.722 262.387 687.957 262.536 688.234 262.653C688.522 262.76 688.917 262.883 689.418 263.021C690.047 263.192 690.559 263.363 690.954 263.533C691.349 263.693 691.685 263.939 691.962 264.269C692.25 264.6 692.399 265.032 692.41 265.565C692.41 266.045 692.277 266.477 692.01 266.861C691.743 267.245 691.365 267.549 690.874 267.773C690.394 267.987 689.839 268.093 689.21 268.093ZM702.465 263.229C702.465 263.507 702.449 263.8 702.417 264.109H695.409C695.463 264.973 695.756 265.651 696.289 266.141C696.833 266.621 697.489 266.861 698.257 266.861C698.887 266.861 699.409 266.717 699.825 266.429C700.252 266.131 700.551 265.736 700.721 265.245H702.289C702.055 266.088 701.585 266.776 700.881 267.309C700.177 267.832 699.303 268.093 698.257 268.093C697.425 268.093 696.679 267.907 696.017 267.533C695.367 267.16 694.855 266.632 694.481 265.949C694.108 265.256 693.921 264.456 693.921 263.549C693.921 262.643 694.103 261.848 694.465 261.165C694.828 260.483 695.335 259.96 695.985 259.597C696.647 259.224 697.404 259.037 698.257 259.037C699.089 259.037 699.825 259.219 700.465 259.581C701.105 259.944 701.596 260.445 701.937 261.085C702.289 261.715 702.465 262.429 702.465 263.229ZM700.961 262.925C700.961 262.371 700.839 261.896 700.593 261.501C700.348 261.096 700.012 260.792 699.585 260.589C699.169 260.376 698.705 260.269 698.193 260.269C697.457 260.269 696.828 260.504 696.305 260.973C695.793 261.443 695.5 262.093 695.425 262.925H700.961Z"
            fill="#686868"
          />
          <path
            id="Mid"
            d="M681.48 434.496V445.568H680.024V437.312L676.344 445.568H675.32L671.624 437.296V445.568H670.168V434.496H671.736L675.832 443.648L679.928 434.496H681.48ZM684.702 435.376C684.424 435.376 684.19 435.28 683.998 435.088C683.806 434.896 683.71 434.661 683.71 434.384C683.71 434.106 683.806 433.872 683.998 433.68C684.19 433.488 684.424 433.392 684.702 433.392C684.968 433.392 685.192 433.488 685.374 433.68C685.566 433.872 685.662 434.106 685.662 434.384C685.662 434.661 685.566 434.896 685.374 435.088C685.192 435.28 684.968 435.376 684.702 435.376ZM685.406 436.8V445.568H683.95V436.8H685.406ZM687.343 441.152C687.343 440.256 687.524 439.472 687.887 438.8C688.25 438.117 688.746 437.589 689.375 437.216C690.015 436.842 690.73 436.656 691.519 436.656C692.202 436.656 692.836 436.816 693.423 437.136C694.01 437.445 694.458 437.856 694.767 438.368V433.728H696.239V445.568H694.767V443.92C694.479 444.442 694.052 444.874 693.487 445.216C692.922 445.546 692.26 445.712 691.503 445.712C690.724 445.712 690.015 445.52 689.375 445.136C688.746 444.752 688.25 444.213 687.887 443.52C687.524 442.826 687.343 442.037 687.343 441.152ZM694.767 441.168C694.767 440.506 694.634 439.93 694.367 439.44C694.1 438.949 693.738 438.576 693.279 438.32C692.831 438.053 692.335 437.92 691.791 437.92C691.247 437.92 690.751 438.048 690.303 438.304C689.855 438.56 689.498 438.933 689.231 439.424C688.964 439.914 688.831 440.49 688.831 441.152C688.831 441.824 688.964 442.41 689.231 442.912C689.498 443.402 689.855 443.781 690.303 444.048C690.751 444.304 691.247 444.432 691.791 444.432C692.335 444.432 692.831 444.304 693.279 444.048C693.738 443.781 694.1 443.402 694.367 442.912C694.634 442.41 694.767 441.829 694.767 441.168Z"
            fill="#686868"
          />
          <path
            id="Apex"
            d="M670.94 605.962H666.076L665.18 608.442H663.644L667.676 597.354H669.356L673.372 608.442H671.836L670.94 605.962ZM670.524 604.778L668.508 599.146L666.492 604.778H670.524ZM676.585 601.29C676.873 600.789 677.3 600.373 677.865 600.042C678.441 599.701 679.108 599.53 679.865 599.53C680.644 599.53 681.348 599.717 681.977 600.09C682.617 600.464 683.119 600.992 683.481 601.674C683.844 602.346 684.025 603.13 684.025 604.026C684.025 604.912 683.844 605.701 683.481 606.394C683.119 607.088 682.617 607.626 681.977 608.01C681.348 608.394 680.644 608.586 679.865 608.586C679.119 608.586 678.457 608.421 677.881 608.09C677.316 607.749 676.884 607.328 676.585 606.826V612.602H675.129V599.674H676.585V601.29ZM682.537 604.026C682.537 603.365 682.404 602.789 682.137 602.298C681.871 601.808 681.508 601.434 681.049 601.178C680.601 600.922 680.105 600.794 679.561 600.794C679.028 600.794 678.532 600.928 678.073 601.194C677.625 601.45 677.263 601.829 676.985 602.33C676.719 602.821 676.585 603.392 676.585 604.042C676.585 604.704 676.719 605.285 676.985 605.786C677.263 606.277 677.625 606.656 678.073 606.922C678.532 607.178 679.028 607.306 679.561 607.306C680.105 607.306 680.601 607.178 681.049 606.922C681.508 606.656 681.871 606.277 682.137 605.786C682.404 605.285 682.537 604.698 682.537 604.026ZM693.942 603.722C693.942 604 693.926 604.293 693.894 604.602H686.886C686.939 605.466 687.232 606.144 687.766 606.634C688.31 607.114 688.966 607.354 689.734 607.354C690.363 607.354 690.886 607.21 691.302 606.922C691.728 606.624 692.027 606.229 692.198 605.738H693.766C693.531 606.581 693.062 607.269 692.358 607.802C691.654 608.325 690.779 608.586 689.734 608.586C688.902 608.586 688.155 608.4 687.494 608.026C686.843 607.653 686.331 607.125 685.958 606.442C685.584 605.749 685.398 604.949 685.398 604.042C685.398 603.136 685.579 602.341 685.942 601.658C686.304 600.976 686.811 600.453 687.462 600.09C688.123 599.717 688.88 599.53 689.734 599.53C690.566 599.53 691.302 599.712 691.942 600.074C692.582 600.437 693.072 600.938 693.414 601.578C693.766 602.208 693.942 602.922 693.942 603.722ZM692.438 603.418C692.438 602.864 692.315 602.389 692.07 601.994C691.824 601.589 691.488 601.285 691.062 601.082C690.646 600.869 690.182 600.762 689.67 600.762C688.934 600.762 688.304 600.997 687.782 601.466C687.27 601.936 686.976 602.586 686.902 603.418H692.438ZM700.44 608.442L698.36 605.178L696.36 608.442H694.84L697.672 604.09L694.84 599.674H696.488L698.568 602.922L700.552 599.674H702.072L699.256 604.01L702.088 608.442H700.44Z"
            fill="#686868"
          />
        </g>
        <g id="Metastases">{textToSvg && tumorsWithLabel.map(toEllipse)}</g>
        <defs>
          <filter
            id="filter0_ProstateTumorImage"
            x={363.721}
            y={226.837}
            width={193.648}
            height={173.79}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy={4} />
            <feGaussianBlur stdDeviation={22.5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_ProstateTumorImage"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_ProstateTumorImage"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_ProstateTumorImage"
            x={467.369}
            y={226.837}
            width={193.652}
            height={173.79}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy={4} />
            <feGaussianBlur stdDeviation={22.5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_ProstateTumorImage"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_ProstateTumorImage"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_ProstateTumorImage"
            x={365.716}
            y={143.006}
            width={191.653}
            height={173.831}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy={4} />
            <feGaussianBlur stdDeviation={22.5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_ProstateTumorImage"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_ProstateTumorImage"
              result="shape"
            />
          </filter>
          <filter
            id="filter3_ProstateTumorImage"
            x={467.369}
            y={143.006}
            width={191.628}
            height={173.831}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy={4} />
            <feGaussianBlur stdDeviation={22.5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_ProstateTumorImage"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_ProstateTumorImage"
              result="shape"
            />
          </filter>
          <filter
            id="filter4_ProstateTumorImage"
            x={362.745}
            y={408.348}
            width={194.624}
            height={176.597}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy={4} />
            <feGaussianBlur stdDeviation={22.5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_ProstateTumorImage"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_ProstateTumorImage"
              result="shape"
            />
          </filter>
          <filter
            id="filter5_ProstateTumorImage"
            x={467.369}
            y={408.348}
            width={194.628}
            height={176.618}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy={4} />
            <feGaussianBlur stdDeviation={22.5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_ProstateTumorImage"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_ProstateTumorImage"
              result="shape"
            />
          </filter>
          <filter
            id="filter6_ProstateTumorImage"
            x={367.524}
            y={321.89}
            width={189.845}
            height={176.461}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy={4} />
            <feGaussianBlur stdDeviation={22.5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_ProstateTumorImage"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_ProstateTumorImage"
              result="shape"
            />
          </filter>
          <filter
            id="filter7_ProstateTumorImage"
            x={467.369}
            y={321.884}
            width={189.835}
            height={176.466}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy={4} />
            <feGaussianBlur stdDeviation={22.5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_ProstateTumorImage"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_ProstateTumorImage"
              result="shape"
            />
          </filter>
          <filter
            id="filter8_ProstateTumorImage"
            x={364.299}
            y={583.467}
            width={193.07}
            height={172.713}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy={4} />
            <feGaussianBlur stdDeviation={22.5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_ProstateTumorImage"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_ProstateTumorImage"
              result="shape"
            />
          </filter>
          <filter
            id="filter9_ProstateTumorImage"
            x={467.369}
            y={583.467}
            width={193.032}
            height={172.713}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy={4} />
            <feGaussianBlur stdDeviation={22.5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_ProstateTumorImage"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_ProstateTumorImage"
              result="shape"
            />
          </filter>
          <filter
            id="filter10_ProstateTumorImage"
            x={362.845}
            y={500.863}
            width={194.524}
            height={172.601}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy={4} />
            <feGaussianBlur stdDeviation={22.5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_ProstateTumorImage"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_ProstateTumorImage"
              result="shape"
            />
          </filter>
          <filter
            id="filter11_ProstateTumorImage"
            x={467.369}
            y={500.818}
            width={194.524}
            height={172.647}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy={4} />
            <feGaussianBlur stdDeviation={22.5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_ProstateTumorImage"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_ProstateTumorImage"
              result="shape"
            />
          </filter>
          <filter
            id="filter12_ProstateTumorImage"
            x={330.676}
            y={19}
            width={363.027}
            height={218.858}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy={25} />
            <feGaussianBlur stdDeviation={22} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_ProstateTumorImage"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_ProstateTumorImage"
              result="shape"
            />
          </filter>
          <filter
            id="filter13_ProstateTumorImage"
            x={322.331}
            y={85.7621}
            width={182.224}
            height={146.142}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy={4} />
            <feGaussianBlur stdDeviation={22.5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_ProstateTumorImage"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_ProstateTumorImage"
              result="shape"
            />
          </filter>
          <filter
            id="filter14_ProstateTumorImage"
            x={519.83}
            y={85.7621}
            width={182.224}
            height={146.142}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy={4} />
            <feGaussianBlur stdDeviation={22.5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_ProstateTumorImage"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_ProstateTumorImage"
              result="shape"
            />
          </filter>
          <filter
            id="filter15_i_ProstateTumorImage"
            x={418.705}
            y={542.599}
            width={98.6647}
            height={81.8655}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx={5} dy={-10} />
            <feGaussianBlur stdDeviation={8} />
            <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_ProstateTumorImage"
            />
          </filter>
          <filter
            id="filter16_i_ProstateTumorImage"
            x={512.369}
            y={542.599}
            width={98.6699}
            height={81.8655}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx={5} dy={-10} />
            <feGaussianBlur stdDeviation={8} />
            <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_ProstateTumorImage"
            />
          </filter>
          <filter
            id="filter17_i_ProstateTumorImage"
            x={419.466}
            y={614.464}
            width={97.9041}
            height={81.8448}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx={5} dy={-10} />
            <feGaussianBlur stdDeviation={8} />
            <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_ProstateTumorImage"
            />
          </filter>
          <filter
            id="filter18_i_ProstateTumorImage"
            x={512.369}
            y={614.467}
            width={97.9041}
            height={81.8619}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx={5} dy={-10} />
            <feGaussianBlur stdDeviation={8} />
            <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_ProstateTumorImage"
            />
          </filter>
          <filter
            id="filter19_i_ProstateTumorImage"
            x={512.369}
            y={363.62}
            width={95.2767}
            height={85.7314}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx={5} dy={-10} />
            <feGaussianBlur stdDeviation={8} />
            <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_ProstateTumorImage"
            />
          </filter>
          <filter
            id="filter20_i_ProstateTumorImage"
            x={422.092}
            y={363.62}
            width={95.277}
            height={85.7314}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx={5} dy={-10} />
            <feGaussianBlur stdDeviation={8} />
            <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_ProstateTumorImage"
            />
          </filter>
          <filter
            id="filter21_i_ProstateTumorImage"
            x={418.611}
            y={439.351}
            width={98.7596}
            height={85.7035}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx={5} dy={-10} />
            <feGaussianBlur stdDeviation={8} />
            <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_ProstateTumorImage"
            />
          </filter>
          <filter
            id="filter22_i_ProstateTumorImage"
            x={512.369}
            y={439.348}
            width={98.7608}
            height={85.7279}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx={5} dy={-10} />
            <feGaussianBlur stdDeviation={8} />
            <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_ProstateTumorImage"
            />
          </filter>
          <filter
            id="filter23_i_ProstateTumorImage"
            x={512.369}
            y={184.831}
            width={96.6309}
            height={83.0066}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx={5} dy={-10} />
            <feGaussianBlur stdDeviation={8} />
            <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_ProstateTumorImage"
            />
          </filter>
          <filter
            id="filter24_i_ProstateTumorImage"
            x={420.743}
            y={184.831}
            width={96.6262}
            height={83.0066}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx={5} dy={-10} />
            <feGaussianBlur stdDeviation={8} />
            <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_ProstateTumorImage"
            />
          </filter>
          <filter
            id="filter25_i_ProstateTumorImage"
            x={419.57}
            y={257.84}
            width={97.8007}
            height={83.0117}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx={5} dy={-10} />
            <feGaussianBlur stdDeviation={8} />
            <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_ProstateTumorImage"
            />
          </filter>
          <filter
            id="filter26_i_ProstateTumorImage"
            x={512.369}
            y={257.837}
            width={97.8026}
            height={83.0117}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx={5} dy={-10} />
            <feGaussianBlur stdDeviation={8} />
            <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_ProstateTumorImage"
            />
          </filter>
          <linearGradient
            id="paint0_linear_ProstateTumorImage"
            x1={512.19}
            y1={38}
            x2={512.19}
            y2={168.858}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F9F9F9" />
            <stop offset={0.494792} stopColor="white" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
);

export default ProstateTumorImage;
